import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import moment from 'moment';

class CurrentSelection extends Component {
    render() {
        const { date, service, startTime, endTime, price, onDateEdit, onServiceEdit, onTimeEdit, text } = this.props;

        return (
            <Container style={{ backgroundColor: '#F9F9FA', border: '1px solid #E0E0E0', borderRadius: '8px' }}>
                <Row className="my-2 d-flex justify-content-center" style={{ margin: '0 auto' }}>

                    {text && (
                        <Col xs="auto" className="d-flex align-items-center">
                            <span className="fw-medium"><small>{text}</small></span>
                        </Col>
                    )}

                    <Col xs="auto" className="d-flex align-items-center">
                        <span className="fw-light">Date:</span> <span className="fw-medium ms-2">{date}</span>
                    </Col>
                    <Col xs="auto" className="d-flex align-items-center">
                        <Button color="link" onClick={() => onDateEdit()} className="p-0">
                            <img src="edit.png" alt="Edit" style={{ height: '20px' }} />
                        </Button>
                    </Col>

                    {service !== "Unknown" && (
                        <>
                            <Col xs="auto" className="d-flex align-items-center border-start ps-3">
                                <span className="fw-light">Service:</span> <span className="fw-medium ms-2">{service}</span>
                            </Col>
                            <Col xs="auto" className="d-flex align-items-center">
                                <Button color="link" onClick={() => onServiceEdit()} className="p-0">
                                    <img src="edit.png" alt="Edit" style={{ height: '20px' }} />
                                </Button>
                            </Col>
                        </>
                    )}

                    {startTime !== "" && endTime !== "" && (
                        <>
                            <Col xs="auto" className="d-flex align-items-center border-start ps-3">
                                <span className="fw-light">Time:</span> <span className="fw-medium ms-2">{moment(startTime).format('LT') + ' - ' + moment(endTime).format('LT')}</span>
                            </Col>
                            <Col xs="auto" className="d-flex align-items-center">
                                <Button color="link" onClick={() => onTimeEdit()} className="p-0">
                                    <img src="edit.png" alt="Edit" style={{ height: '20px' }} />
                                </Button>
                            </Col>
                        </>
                    )}

                    {Number(price) > 0 && (
                        <Col xs="auto" className="d-flex align-items-center border-start ps-3">
                            <span className="fw-light">Price: </span>
                            <span className="fw-medium ms-2">
                                {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price)}
                            </span>
                        </Col>
                    )}
                </Row>
            </Container>
        );
    }
}

export default CurrentSelection;
